<template>
  <v-container grid-list-md page>
    <v-flex>
      <h1 class="title primary--text my-3">アーティスト一覧</h1>
      <v-layout row wrap>
          <v-flex xs12 sm6 v-for="item in artist_list" :key="item.artist_id">
            <v-card>
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs7>
                    <div class="title mb-2 orange--text text--darken-2">{{ item.artist_name }}</div>
                    <v-divider class="my-3"></v-divider>
                    <div>{{ item.profile }}</div>
                    <v-btn outline block color="indigo" @click="artistDetail(item.artist_id)">詳細へ</v-btn>
                  </v-flex>
                  <v-flex xs5>
                    <v-card-media
                      v-if="item.main_large_image == null"
                      src="/static/unknown.png"
                      height="125px"
                      contain
                    ></v-card-media>
                    <v-card-media
                      v-else
                      :src="item.main_large_image"
                      height="125px"
                      contain
                    ></v-card-media>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>

    </v-flex>
  </v-container>
</template>

<script>
import ArtistService from '@/components/services/ArtistService.vue'
export default {
  name: 'Artist',
  data () {
    return {
      artist_list: []
    }
  },
  created () {
    this.getArtistList()
  },
  watch: {
    artist_list () {
      this.$nextTick(() => {
        let positionY = sessionStorage.getItem('positionY')
        scrollTo(0, positionY)
        setTimeout(function () {
          scrollTo(0, positionY)
        }, 500)
      })
    }
  },
  methods: {
    /**
     * アーティストを取得
     **/
    getArtistList () {
      this.logging('methods: getArtistList')
      var transactionid = this.$store.state.transactionId
      ArtistService.getArtistList(transactionid, (response) => {
        this.logging(response)
        this.artist_list = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * 詳細ボタンをクリックしたときの処理
     **/
    artistDetail (artistId) {
      this.$router.push({path: '/home/artist/detail/' + artistId})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/artist/Index.vue